import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';

import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { TrainersGridMetaModel } from 'common/models/page-models/Trainers Model/trainers-grid-meta.model';
import { TrainersListingModel } from 'common/models/page-models/Trainers Model/trainers-params.model';
import { TrainersGridDataService } from 'common/services/data-services/admin/trainer/trainers-grid.data.services';

@Injectable({
  providedIn: 'root',
})
export class TrainersGridWidgetService extends GridWidgetService<
  TrainersModel,
  TrainersListingModel
> {
  constructor(
    protected override ds: TrainersGridDataService,
    protected systemService: SystemService
  ) {
    super(ds);
  }

  createQueryParams(queryParam): GridParams {
    for (const key in queryParam) {
      this.queryparm[key] = queryParam[key];
    }
    return this.queryparm;
  }

  getMetaModel(): MetaModel {
    const meta = new TrainersGridMetaModel().getMetaModel();
    return meta;
  }


}
